// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressSearchController from "./address_search_controller"
application.register("address-search", AddressSearchController)

import AddressValidationController from "./address_validation_controller"
application.register("address-validation", AddressValidationController)

import AutosubmitFormController from "./autosubmit_form_controller"
application.register("autosubmit-form", AutosubmitFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CodeAutoSubmitController from "./code_auto_submit_controller"
application.register("code-auto-submit", CodeAutoSubmitController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import ConfirmAllowancesController from "./confirm_allowances_controller"
application.register("confirm-allowances", ConfirmAllowancesController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import ContactSalesModalController from "./contact_sales_modal_controller"
application.register("contact-sales-modal", ContactSalesModalController)

import CustomAllowancesController from "./custom_allowances_controller"
application.register("custom-allowances", CustomAllowancesController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DisabledTooltipController from "./disabled_tooltip_controller"
application.register("disabled-tooltip", DisabledTooltipController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditAllowanceDialogController from "./edit_allowance_dialog_controller"
application.register("edit-allowance-dialog", EditAllowanceDialogController)

import EmployeesListController from "./employees_list_controller"
application.register("employees-list", EmployeesListController)

import EmployerAllowancesController from "./employer_allowances_controller"
application.register("employer-allowances", EmployerAllowancesController)

import EmployerOnboardingConfigController from "./employer_onboarding_config_controller"
application.register("employer-onboarding-config", EmployerOnboardingConfigController)

import EmployerSettingsTabsController from "./employer_settings_tabs_controller"
application.register("employer-settings-tabs", EmployerSettingsTabsController)

import EventTrackerController from "./event_tracker_controller"
application.register("event-tracker", EventTrackerController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FlipCardController from "./flip_card_controller"
application.register("flip-card", FlipCardController)

import FormDisableSubmitController from "./form_disable_submit_controller"
application.register("form-disable-submit", FormDisableSubmitController)

import FormSubmitOnLoadController from "./form_submit_on_load_controller"
application.register("form-submit-on-load", FormSubmitOnLoadController)

import GenderSelectController from "./gender_select_controller"
application.register("gender-select", GenderSelectController)

import GranularAllowancesComparisonController from "./granular_allowances_comparison_controller"
application.register("granular-allowances-comparison", GranularAllowancesComparisonController)

import GranularAllowancesController from "./granular_allowances_controller"
application.register("granular-allowances", GranularAllowancesController)

import GranularAllowancesEstimateController from "./granular_allowances_estimate_controller"
application.register("granular-allowances-estimate", GranularAllowancesEstimateController)

import GranularAllowancesMapController from "./granular_allowances_map_controller"
application.register("granular-allowances-map", GranularAllowancesMapController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import InfoTooltipController from "./info_tooltip_controller"
application.register("info-tooltip", InfoTooltipController)

import InputMaskController from "./input_mask_controller"
application.register("input-mask", InputMaskController)

import MagicLinkFormController from "./magic_link_form_controller"
application.register("magic-link-form", MagicLinkFormController)

import MedicalPlansFilterController from "./medical_plans_filter_controller"
application.register("medical-plans-filter", MedicalPlansFilterController)

import MemberProfileController from "./member_profile_controller"
application.register("member-profile", MemberProfileController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NewMemberFormController from "./new_member_form_controller"
application.register("new-member-form", NewMemberFormController)

import OrderPhysicalCardDialogController from "./order_physical_card_dialog_controller"
application.register("order-physical-card-dialog", OrderPhysicalCardDialogController)

import ParticipantsController from "./participants_controller"
application.register("participants", ParticipantsController)

import PayScheduleFormController from "./pay_schedule_form_controller"
application.register("pay-schedule-form", PayScheduleFormController)

import PdfController from "./pdf_controller"
application.register("pdf", PdfController)

import PlaidLinkController from "./plaid_link_controller"
application.register("plaid-link", PlaidLinkController)

import PlanComparisonController from "./plan_comparison_controller"
application.register("plan-comparison", PlanComparisonController)

import PlanDocumentsDisplayController from "./plan_documents_display_controller"
application.register("plan-documents-display", PlanDocumentsDisplayController)

import PosthogIdentifyController from "./posthog_identify_controller"
application.register("posthog-identify", PosthogIdentifyController)

import PosthogResetController from "./posthog_reset_controller"
application.register("posthog-reset", PosthogResetController)

import RemoveParticipantController from "./remove_participant_controller"
application.register("remove-participant", RemoveParticipantController)

import RevealPasswordController from "./reveal_password_controller"
application.register("reveal-password", RevealPasswordController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TimestampLocalizerController from "./timestamp_localizer_controller"
application.register("timestamp-localizer", TimestampLocalizerController)

import ToggleHiddenController from "./toggle_hidden_controller"
application.register("toggle-hidden", ToggleHiddenController)

import ToggleLoomController from "./toggle_loom_controller"
application.register("toggle-loom", ToggleLoomController)

import TosAcceptanceController from "./tos_acceptance_controller"
application.register("tos-acceptance", TosAcceptanceController)

import TransactionMarkLossDialogController from "./transaction_mark_loss_dialog_controller"
application.register("transaction-mark-loss-dialog", TransactionMarkLossDialogController)

import TransitionController from "./transition_controller"
application.register("transition", TransitionController)

import TransitionOpacityController from "./transition_opacity_controller"
application.register("transition-opacity", TransitionOpacityController)

import VgsCollectChangePinController from "./vgs_collect_change_pin_controller"
application.register("vgs-collect-change-pin", VgsCollectChangePinController)

import VgsCollectCvv2Controller from "./vgs_collect_cvv2_controller"
application.register("vgs-collect-cvv2", VgsCollectCvv2Controller)

import VgsCollectSetPinController from "./vgs_collect_set_pin_controller"
application.register("vgs-collect-set-pin", VgsCollectSetPinController)

import VgsShowController from "./vgs_show_controller"
application.register("vgs-show", VgsShowController)

import WebauthnAuthController from "./webauthn_auth_controller"
application.register("webauthn-auth", WebauthnAuthController)

import WebauthnRegisterController from "./webauthn_register_controller"
application.register("webauthn-register", WebauthnRegisterController)
